export class IACError extends Error {

  name = 'IACError';
  message;
  hash: string = null;

  /*
   * @param {string} [message] - The error message.
   * @param {string} [hash] - An optional hash, which will be linked in debug mode.
   */
  constructor(
    message = 'An unknown IAC error occurred',
    hash: string = null,
  ) {
    super(message);
    this.message = message;
    this.hash = hash;
  }
}
